import { z } from "zod";

export const TicketingManagerSchema = z.object({
  uuid: z.uuid(),
});

export type TicketingManager = z.infer<typeof TicketingManagerSchema>;

export const TicketingManagersResponseSchema = z.object({
  data: z.array(TicketingManagerSchema),
});

export type TicketingManagersResponse = z.infer<typeof TicketingManagersResponseSchema>;
